import { ApiError } from "../api";
import { evaluationFeedback } from "./evaluation-feedback";
const codes = [
  "award_policy_required",
  "award_policy_changed",
  "award_policy_invalid",
  "award_self_approval",
  "award_approver_unavailable",
  "award_approver_available",
  "award_approver_duplicate",
  "award_reason_required",
  "award_step_changed",
  "award_transition_conflict",
  "award_approval_pending",
  "award_replacement_required",
  "award_publication_changed",
  "award_allocation_changed",
  "evaluation_completion_changed",
  "evaluation_completion_required",
] as const;
export type AwardFeedback =
  ReturnType<typeof evaluationFeedback> | (typeof codes)[number];
export function isAwardFeedbackCode(
  value: unknown,
): value is (typeof codes)[number] {
  return codes.some((code) => code === value);
}
export function awardReadiness(code: string): AwardFeedback {
  return awardFeedback(
    new ApiError("Award readiness", { kind: "conflict", code }),
  );
}
export function awardFeedback(error: unknown): AwardFeedback {
  if (error instanceof ApiError && codes.some((x) => x === error.code))
    return error.code as (typeof codes)[number];
  return evaluationFeedback(error);
}
